'use client';

import { useWritingPreferences } from '@sola/supporter-sdk/hooks/settings.ts';

export const LetterWritingPreferences = () => {
  const { hasPrint, hasEmail, isLoading } = useWritingPreferences();
  return (
    <div>
      <h1>Letter Writting Preferences Place Holder</h1>
      {isLoading && <p>is loading ...</p>}
      {!isLoading && (
        <ul>
          <li>
            <span>Email: </span>
            {String(hasEmail)}
          </li>
          <li>
            <span>High-Quality Print: </span>
            {String(hasPrint)}
          </li>
        </ul>
      )}
    </div>
  );
};
